import { render, staticRenderFns } from "./ActiveTableLayoutIcon.vue?vue&type=template&id=274c8574"
import script from "./ActiveTableLayoutIcon.vue?vue&type=script&lang=js"
export * from "./ActiveTableLayoutIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports